import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  applicationFundingSource,
  updateApplicationFundingSource,
} from '../store/actions/fundingSource/fundingSourceActions';
import useApplicationUid from './useApplicationUid';

const useApplicationFundingSourceDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const applicationFundingSourceDispatch = ({
    data,
    defaultValues,
    onSuccess,
    onError,
  }) => {
    const shouldSkip = isEqual(data, defaultValues);
    if (shouldSkip) {
      onSuccess();
      return;
    }
    const {
      AccountPurpose,
      InitialFundingSourceTypes,
      InitialFundingOtherDetails,
      OngoingFundingSourceTypes,
      OngoingFundingOtherDetails,
    } = data;
    const requestData = {
      applicationUid: ApplicationUid,
      data: {
        AccountPurpose,
        InitialFundingSourceTypes,
        InitialFundingOtherDetails,
        OngoingFundingSourceTypes,
        OngoingFundingOtherDetails,
      },
      onSuccess,
      onError,
    };

    if (defaultValues?.AccountPurpose) {
      dispatch(updateApplicationFundingSource({ ...requestData }));
      return;
    }
    dispatch(
      applicationFundingSource({
        ...requestData,
      }),
    );
  };

  return { applicationFundingSourceDispatch };
};

export default useApplicationFundingSourceDispatch;
